/* =====================================================
   Marisol's Boutique — marisols.js
   Shopify Online Store 2.0 Theme JS
   ===================================================== */

(function () {
  'use strict';

  /* -------------------------------------------------- */
  /* Scroll: sticky header shadow                        */
  /* -------------------------------------------------- */
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 10);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* -------------------------------------------------- */
  /* Mobile menu                                         */
  /* -------------------------------------------------- */
  const hamburger = document.querySelector('.hamburger');
  const drawer = document.querySelector('.mobile-drawer');

  if (hamburger && drawer) {
    hamburger.addEventListener('click', () => {
      const isOpen = hamburger.classList.toggle('open');
      drawer.classList.toggle('open', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
      hamburger.setAttribute('aria-expanded', isOpen);
    });

    // Close on outside click
    document.addEventListener('click', (e) => {
      if (
        hamburger.classList.contains('open') &&
        !hamburger.contains(e.target) &&
        !drawer.contains(e.target)
      ) {
        hamburger.classList.remove('open');
        drawer.classList.remove('open');
        document.body.style.overflow = '';
        hamburger.setAttribute('aria-expanded', false);
      }
    });

    // Close on escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && hamburger.classList.contains('open')) {
        hamburger.classList.remove('open');
        drawer.classList.remove('open');
        document.body.style.overflow = '';
        hamburger.setAttribute('aria-expanded', false);
      }
    });
  }

  /* -------------------------------------------------- */
  /* Scroll reveal animation (IntersectionObserver)      */
  /* -------------------------------------------------- */
  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    document.querySelectorAll('.reveal').forEach((el) => {
      revealObserver.observe(el);
    });
  } else {
    // Fallback for older browsers
    document.querySelectorAll('.reveal').forEach((el) => {
      el.classList.add('visible');
    });
  }

  /* -------------------------------------------------- */
  /* Product gallery — thumbnail switcher               */
  /* -------------------------------------------------- */
  const productPage = document.querySelector('.product-page');
  if (productPage) {
    const mainImg = productPage.querySelector('.product-main-img img');
    const thumbs = productPage.querySelectorAll('.product-thumb');

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.querySelector('img')?.src;
        if (mainImg && src) {
          mainImg.src = src;
        }
        thumbs.forEach((t) => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
  }

  /* -------------------------------------------------- */
  /* Size selector                                       */
  /* -------------------------------------------------- */
  document.querySelectorAll('.size-option:not(.unavailable)').forEach((opt) => {
    opt.addEventListener('click', () => {
      const group = opt.closest('.size-options');
      if (group) {
        group.querySelectorAll('.size-option').forEach((o) => o.classList.remove('selected'));
      }
      opt.classList.add('selected');
    });
  });

  /* -------------------------------------------------- */
  /* Cart quantity controls                              */
  /* -------------------------------------------------- */
  document.querySelectorAll('.cart-qty').forEach((widget) => {
    const input = widget.querySelector('input');
    const minus = widget.querySelector('[data-action="minus"]');
    const plus = widget.querySelector('[data-action="plus"]');

    if (!input) return;

    minus?.addEventListener('click', () => {
      const val = parseInt(input.value, 10) || 1;
      if (val > 1) input.value = val - 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    plus?.addEventListener('click', () => {
      const val = parseInt(input.value, 10) || 1;
      input.value = val + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* -------------------------------------------------- */
  /* Announcement bar — pause-on-hover marquee          */
  /* -------------------------------------------------- */
  const annBar = document.querySelector('.ann-bar');
  if (annBar) {
    annBar.addEventListener('mouseenter', () => {
      annBar.style.animationPlayState = 'paused';
    });
    annBar.addEventListener('mouseleave', () => {
      annBar.style.animationPlayState = 'running';
    });
  }

  /* -------------------------------------------------- */
  /* Staggered reveal for grid children                 */
  /* -------------------------------------------------- */
  document.querySelectorAll('.vibes-grid, .products-grid, .occasions-grid').forEach((grid) => {
    Array.from(grid.children).forEach((child, i) => {
      child.style.transitionDelay = `${i * 0.07}s`;
      if ('IntersectionObserver' in window) {
        child.classList.add('reveal');
        // Observer picks them up after adding class
      } else {
        child.style.opacity = '1';
        child.style.transform = 'none';
      }
    });
  });

  /* Re-run observe for dynamically classed elements */
  if ('IntersectionObserver' in window) {
    const grids = document.querySelectorAll('.vibes-grid > *, .products-grid > *, .occasions-grid > *');
    const staggerObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            staggerObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08 }
    );
    grids.forEach((el) => staggerObserver.observe(el));
  }

  /* -------------------------------------------------- */
  /* Shopify theme editor live updates                  */
  /* -------------------------------------------------- */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      // Re-init reveal after section reload in editor
      document.querySelectorAll('.reveal').forEach((el) => {
        el.classList.add('visible');
      });
    });
  }

})();
